<template>
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="昵称">
          <el-input v-model="formInline.search" placeholder="请输入昵称"></el-input>
        </el-form-item>
        <el-form-item label="申请时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.create_time" type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="point_rmb_id" label="ID" width="60"></el-table-column>
          <el-table-column prop="nickName" label="微信头像" width="70">
            <template slot-scope="scope">
              <img :src="scope.row.user.avatarUrl" width="30" height="30" />
            </template>
          </el-table-column>
          <el-table-column prop="" label="昵称">
            <template slot-scope="scope">
              <span>{{scope.row.user.nickName}}</span>
              <span class="gray9">(用户ID：{{scope.row.user.user_id}})</span>
            </template>
          </el-table-column>
          <el-table-column prop="money" label="兑换金额"></el-table-column>
          <el-table-column prop="point" label="消耗积分"></el-table-column>
          <el-table-column prop="status_desc" label="状态"></el-table-column>
          <el-table-column prop="reason" label="审核说明"></el-table-column>
          <el-table-column prop="create_time" label="申请时间"></el-table-column>
            <el-table-column fixed="right" label="操作" width="200">
                <template slot-scope="scope">
                    <el-button @click="handleAudit(scope.row)" type="text" size="small" v-if="scope.row.status === 0" v-auth="'/education/point/audit'">审核</el-button>
                </template>
            </el-table-column>
        </el-table>
      </div>

        <el-dialog title="审核" :visible.sync="dialogAudit" @close="close" :close-on-click-modal="false" :close-on-press-escape="false" width="900px">
            <el-form size="small" :model="form" label-width="120" ref="form">

                <el-form-item label="状态">
                    <el-radio-group v-model="form.status">
                        <el-radio :label="10">审核通过</el-radio>
                        <el-radio :label="20">审核驳回</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="审核说明" prop="address">
                    <el-input type="textarea" v-model="form.reason" placeholder="审核说明" clearable/>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="close">取 消</el-button>
                <el-button type="primary" @click="save" :disabled="submit_loading">确 定</el-button>
            </div>
        </el-dialog>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
    import { pointAudit, pointList} from "@/api/education";
  export default {
    components: {},
    data() {
      return {
          submit_loading: false,
          dialogAudit: false,
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 10,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          search: '',
          value1: ''
        },
          form:{
              id: '',
              status: 1,
              reason: '',
          }
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();

    },
    methods: {
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
          pointList(Params, true).then(data => {
              console.log(data.data, '')
          self.loading = false;
          self.tableData = data.data.list;
          self.totalDataNumber = data.data.count;
        }).catch(error => {

        });
      },

        handleAudit(row){
          this.form.id = row.point_rmb_id
            this.dialogAudit = true
        },

        // 关闭
        close() {
            this.form = this.$options.data().form
            this.dialogAudit = false
        },
        // 保存
        save() {
            this.submit_loading = true
            pointAudit(this.form).then((result)=>{
                this.$message({message: result.msg, type: 'success'});
                // this.$emit('fetch-data')
                this.getTableList();
                this.submit_loading = false
                this.close()
            }).catch(()=>{
                this.submit_loading = false
            })
        },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        self.getTableList();
      },
    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/user/points/part/points-money.vue